
export const APP_VERSION = "2.6.25";
export const APP_NAME = "Golf Progress Calculator";
